<template>
  <v-container>
    <v-row>
      <v-col>
        <admin-table
          @toParent="forceRerender"
          @closeDialog="closeEdit"
          @openDialog="openEdit"
        />
      </v-col>
    </v-row>
    <v-dialog
      v-model="admin.editAdmin"
      max-width="600"
      scrollable
      transition="dialog-bottom-transition"
      overlay-opacity="0.6"
    >
      <v-card
        elevation="16"
        rounded="lg"
      >
        <v-toolbar
          flat
          dense
          color="color_green"
          dark
        >
          <v-toolbar-title>Admin</v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            @click="closeEdit"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <admin-form
            :key="componentKey"
            @closeDialog="closeEdit"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    AdminTable: () => import('@/components/admin/AdminTable'),
    AdminForm: () => import('@/components/admin/AdminForm')
  },

  computed: {
    ...mapState(['admin'])
  },

  methods: {
    ...mapActions(['changeEditAdmin', 'storeCustomerCRMID']),
    closeEdit() {
      this.changeEditAdmin(false);
    },
    openEdit() {
      this.changeEditAdmin(true);
    },
    itemFromTable() {
      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    }
  }
};
</script>

<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
